"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportExcel = void 0;
const xlsx_1 = __importDefault(require("xlsx"));
const s2ab = (s) => {
    const buffer = new ArrayBuffer(s.length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i !== s.length; ++i)
        view[i] = s.charCodeAt(i) & 0xff;
    return buffer;
};
const workbook2blob = (workbook) => {
    const options = {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
    };
    const workbookOut = xlsx_1.default.write(workbook, options);
    const blob = new Blob([s2ab(workbookOut)], {
        type: "application/octet-stream",
    });
    return blob;
};
const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(a);
};
const exportExcel = (data, handle) => {
    let excelData = data;
    if (handle === null || handle === void 0 ? void 0 : handle.headers) {
        excelData = data.map((item) => {
            var _a;
            const obj = {};
            (_a = handle.headers) === null || _a === void 0 ? void 0 : _a.forEach((header) => {
                obj[header.headerName] = item[header.property];
            });
            return obj;
        });
    }
    const sheet = xlsx_1.default.utils.json_to_sheet(excelData);
    const wb = xlsx_1.default.utils.book_new();
    xlsx_1.default.utils.book_append_sheet(wb, sheet, handle.sheetName);
    const workbookBlob = workbook2blob(wb);
    downloadBlob(workbookBlob, handle.filename + ".xlsx");
};
exports.exportExcel = exportExcel;
